// Sesotho translations
export const st: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Bareki',
  'menu.products': 'Lihlahisoa',
  'menu.users': 'Basebelisi',
  'menu.settings': 'Litlhophiso',
  'menu.logout': 'Tswa',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Taelo e Ncha',
  'order.title': 'Taelo e Ncha',
  'order.customer': 'Moreki',
  'order.products': 'Lihlahisoa',
  'order.total': 'Kakaretso',
  'users.title': 'Basebelisi',
  'users.name': 'Lebitso',
  'users.email': 'Imeile',
  'common.yes': 'E',
  'common.no': 'Che',
  'common.cancel': 'Hlakola',
  'common.save': 'Boloka',
  'common.search': 'Batla',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Kena',
  'login.welcome': 'Kamohelo, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Imeile',
  'signup.phone': 'Mohala',
};